import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";

export const obtenerMembresia = async (id) => {

    let doxUsuario = await obtenerDoc('cuentas', id)
    if (doxUsuario.res) {
        let usuario = doxUsuario.data
        let fecha = usuario.fechaMembresia
        if (fecha){
            return fecha
        }else{
            return 0
        }


    } else {
        return 0
    }


}